// extracted by mini-css-extract-plugin
export var avatarContainer = "_hh-0";
export var avatarTypingWave = "_hh-i";
export var gray = "_hh-f";
export var green = "_hh-c";
export var icon = "_hh-9";
export var image = "_hh-1";
export var lg = "_hh-6";
export var md = "_hh-5";
export var presenceDot = "_hh-b";
export var red = "_hh-d";
export var sm = "_hh-4";
export var status = "_hh-a";
export var typingDot = "_hh-h";
export var typingPill = "_hh-g";
export var xl = "_hh-7";
export var xs = "_hh-3";
export var xxl = "_hh-8";
export var xxs = "_hh-2";
export var yellow = "_hh-e";